import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import React from "react";
import ExpiryPendingRxCard from "./expiry-pending-rx-card";
import PharmacistProductivityCard from "./pharmacist-productivity-card";
import SalesForecastChart from "./sales-forecast-chart";

const Component: React.FC = () => {
    return (
    <div className="flex flex-col items-start justify-start p-4 w-full gap-y-4">
        <span className="text-4xl">Hey there <span className="text-gray-500">Mahmoud?</span></span>
        <span className="text-base text-gray-500 mb-2">Here's a quick look at how things are going.</span>
        <Input prefixIcon={<Search className="w-5 h-5" />} placeholder="Ask anything" />
        <SalesForecastChart />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            <ExpiryPendingRxCard />
            <PharmacistProductivityCard />
        </div>
    </div>
    );
}

export default Component;